module.exports = __webpack_public_path__ + "static/media/1898Sans-Bold.c4720d12.otf";